var CataloguePageView, ProgressbarView, View, config, template, utils, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/catalogue');

View = require('views/base/view');

ProgressbarView = require('views/progressbar-view');

config = require('config');

utils = require('lib/utils');

module.exports = CataloguePageView = (function(_super) {
  __extends(CataloguePageView, _super);

  function CataloguePageView() {
    this.showImageOnLoad = __bind(this.showImageOnLoad, this);
    this.preloadCurrentImages = __bind(this.preloadCurrentImages, this);
    this.initCompleted = __bind(this.initCompleted, this);
    this.initImagePreloader = __bind(this.initImagePreloader, this);
    _ref = CataloguePageView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  CataloguePageView.prototype.autoRender = false;

  CataloguePageView.prototype.className = 'catalogue-page';

  CataloguePageView.prototype.flipbook = null;

  CataloguePageView.prototype.activePages = null;

  CataloguePageView.prototype.containerMethod = 'html';

  CataloguePageView.prototype.turnPageCallback = null;

  CataloguePageView.prototype.isTurning = false;

  CataloguePageView.prototype.regions = {
    '#images-preload-progress': 'preloadProgress'
  };

  CataloguePageView.prototype.template = template;

  CataloguePageView.prototype.events = {
    'mouseover polygon': 'hightlightHotspot',
    'mouseleave polygon': 'unHightlightHotspot',
    'click polygon': 'clickPolygon',
    'click rect': 'hideDescriptions',
    'click .next': 'nextPage',
    'click .prev': 'previousPage'
  };

  CataloguePageView.prototype.listen = {
    'sync model': 'render',
    'addedToDOM': 'initImagePreloader',
    'catalogue:next mediator': 'nextPage',
    'catalogue:previous mediator': 'previousPage',
    'catalogue:goToPage mediator': 'goToPage',
    'catalogue:goToPageByPageNumber mediator': 'goToPageByPageNumber',
    'catalogue:goToStart mediator': 'goToStart',
    'catalogue:goToEnd mediator': 'goToEnd',
    'catalogue:zoomIn mediator': 'zoomIn',
    'catalogue:zoomOut mediator': 'zoomOut',
    'catalogue:print mediator': 'print',
    'catalogue:getActivePage mediator': 'getActivePage',
    'catalogue:hideAllDescriptions mediator': 'hideDescriptions',
    'catalogue:pageTurned mediator': 'hideDescriptions',
    'catalogue:pageTurned mediator': 'preloadCurrentImages',
    'catalogue:higlelightHotspotByTitle mediator': 'higlelightHotspotByTitle',
    'catalogue:setTurnPageCallback mediator': 'setTurnPageCallback',
    'catalogue:disable mediator': 'disable'
  };

  CataloguePageView.prototype.addProgressbarBlock = function(region) {
    var progressbarSubView;
    progressbarSubView = new ProgressbarView({
      region: region
    });
    return this.subview('progressBar', progressbarSubView);
  };

  CataloguePageView.prototype.initImagePreloader = function() {
    var imageLoader, images, totalImages, totalLoaded,
      _this = this;
    this.flipbook = this.$("#flipbook");
    if (!config.preloadingThumbs) {
      this.initCompleted();
      return;
    }
    this.addProgressbarBlock('preloadProgress');
    this.preloadCurrentImages([0, 1]);
    images = this.flipbook.find('img:lt(5)').toArray();
    images = images.concat($("#thumbnails img:lt(30), #flipbook .page:lt(" + config.preloadNum + ") img").toArray());
    totalImages = images.length;
    totalLoaded = 0;
    imageLoader = new imagesLoaded(images);
    imageLoader.on('progress', function(instance, image) {
      var progress;
      progress = (++totalLoaded / totalImages).toPrecision(3);
      return _this.publishEvent('progressUpdate', progress);
    });
    return imageLoader.on('always', this.initCompleted);
  };

  CataloguePageView.prototype.initCompleted = function() {
    this.initPrevNextButtons();
    this.initFlip();
    this.initZoom();
    return this.publishEvent('catalogue:initCompleted');
  };

  CataloguePageView.prototype.initPrevNextButtons = function() {
    var _this = this;
    return this.$(".prev-next-page").each(function(index, elem) {
      if (index % 2 === 0) {
        return $(elem).addClass('next');
      } else {
        return $(elem).addClass('prev');
      }
    });
  };

  CataloguePageView.prototype.initFlip = function() {
    var imageNormalSize,
      _this = this;
    if (!this.flipbook.length) {
      return;
    }
    imageNormalSize = this.model.get('image_sizes').normal;
    this.flipbook.css('margin-top', ($('body').height() - imageNormalSize.height - 107) / 2);
    return this.flipbook.turn({
      width: imageNormalSize.width * 2,
      height: imageNormalSize.height,
      autoCenter: true,
      when: {
        start: function(event, pageObject, corner) {
          return _this.isTurning = true;
        },
        end: function(event, pageObject, corner) {
          return _this.isTurning = false;
        },
        turned: function(event, page, view) {
          _this.activePages = view;
          _this.publishEvent('catalogue:pageTurned', _this.activePages);
          $('.page-wrapper').removeClass('active');
          $(".page-wrapper[page='" + view[0] + "']").addClass('active');
          $(".page-wrapper[page='" + view[1] + "']").addClass('active');
          if (_this.turnPageCallback) {
            _this.turnPageCallback();
            return _this.turnPageCallback = null;
          }
        }
      }
    });
  };

  CataloguePageView.prototype.disable = function(isDisable) {
    return this.flipbook.turn('disable', isDisable);
  };

  CataloguePageView.prototype.initZoom = function() {
    var imageNormalSize,
      _this = this;
    this.flipZoom = this.$(".magazine-viewport");
    if (!this.flipZoom.length || !this.flipbook.length) {
      return;
    }
    this.flipZoom.zoom({
      flipbook: this.flipbook,
      when: {
        zoomIn: function() {
          return _this.flipZoom.toggleClass('zoomedOut zoomedIn');
        },
        zoomOut: function() {
          _this.flipZoom.toggleClass('zoomedOut zoomedIn');
          return setTimeout(function() {
            return _this.flipZoom.toggleClass('animated');
          }, 0);
        },
        swipeLeft: function() {},
        swipeRight: function() {}
      }
    });
    setTimeout(function() {
      return _this.flipZoom.toggleClass('animated');
    }, 0);
    imageNormalSize = this.model.get('image_sizes').normal;
    return this.$('.container').width(imageNormalSize.width).height(imageNormalSize.height).css('left', -imageNormalSize.width / 2);
  };

  CataloguePageView.prototype.hightlightHotspot = function(e) {
    $(e.currentTarget).attr('stroke-opacity', 1);
    if (this.isTurning) {

    }
  };

  CataloguePageView.prototype.unHightlightHotspot = function(e) {
    $(e.currentTarget).attr('stroke-opacity', 0);
    if (this.isTurning) {

    }
  };

  CataloguePageView.prototype.clickPolygon = function(e) {
    if (this.isTurning) {
      return;
    }
    if (utils.isMobile.isAndroidNativeBrawser()) {
      return;
    }
    return this.clickHotspot($(e.currentTarget));
  };

  CataloguePageView.prototype.higlelightHotspotByTitle = function(title) {
    var $polygon;
    $polygon = this.$("polygon[title='" + title + "']");
    return this.clickHotspot($polygon);
  };

  CataloguePageView.prototype.clickHotspot = function($polygon) {
    var hotspot, url;
    this.publishEvent('catalogue:hideAllDescriptions');
    url = $polygon.attr('data-url');
    if (/^https?:\/\//ig.test(url)) {
      hotspot = {
        url: url,
        points: $polygon.attr('points'),
        page: $polygon.attr('data-page'),
        title: $polygon.attr('title'),
        polygonHeight: this.getPolygonHeight($polygon),
        polygonWidth: this.getPolygonWidth($polygon),
        left: $polygon.offset().left - $polygon.parents('svg').offset().left,
        top: $polygon.offset().top - $polygon.parents('svg').offset().top,
        offsetPosition: $polygon.offset(),
        elevation: 0
      };
      this.showDescription(hotspot);
      return;
    }
    return this.publishEvent('catalogue:goToPage', url.replace("page://", ""));
  };

  CataloguePageView.prototype.getPolygonHeight = function($polygon) {
    var points, tops;
    points = $polygon.attr('points').split(/,|\s/ig);
    tops = _(points).map(function(v, i) {
      if (i % 2 !== 0) {
        return parseInt(v);
      }
    });
    tops = _(tops).compact();
    return _(tops).max() - _(tops).min();
  };

  CataloguePageView.prototype.getPolygonWidth = function($polygon) {
    var lefts, points;
    points = $polygon.attr('points').split(/,|\s/ig);
    lefts = _(points).map(function(v, i) {
      if ((i % 2) === 0) {
        return parseInt(v);
      }
    });
    lefts = _(lefts).compact();
    return _(lefts).max() - _(lefts).min();
  };

  CataloguePageView.prototype.setTurnPageCallback = function(callback) {
    return this.turnPageCallback = callback;
  };

  CataloguePageView.prototype.showDescription = function(hotspot) {
    this.$("#map-" + hotspot.page + " defs mask polygon").attr('points', hotspot.points);
    this.$("[page='" + this.activePages[0] + "'] svg rect, [page='" + this.activePages[1] + "'] svg rect").attr('visibility', 'visible');
    this.publishEvent('catalogue:disable', true);
    return this.publishEvent('catalogue:showDescription', hotspot);
  };

  CataloguePageView.prototype.hideDescriptions = function() {
    this.$(".page-wrapper svg rect").attr('visibility', 'hidden');
    this.$(".page-wrapper svg mask polygon").attr('points', '');
    this.publishEvent('catalogue:disable', false);
    return this.publishEvent('catalogue:hideDescription');
  };

  CataloguePageView.prototype.goToPage = function(page) {
    var pageNum, _ref1;
    if (page < 1) {
      return;
    }
    pageNum = this.model.get('pages').length;
    if (page > pageNum) {
      page = pageNum;
    }
    if ((_ref1 = this.flipbook) != null ? _ref1.length : void 0) {
      return this.flipbook.turn("page", page);
    }
  };

  CataloguePageView.prototype.goToPageByPageNumber = function(page) {
    page += this.model.getPagesOffset();
    return this.goToPage(page);
  };

  CataloguePageView.prototype.nextPage = function() {
    var _ref1;
    if ((_ref1 = this.flipbook) != null ? _ref1.length : void 0) {
      return this.flipbook.turn("next");
    }
  };

  CataloguePageView.prototype.previousPage = function() {
    var _ref1;
    if ((_ref1 = this.flipbook) != null ? _ref1.length : void 0) {
      return this.flipbook.turn("previous");
    }
  };

  CataloguePageView.prototype.goToStart = function() {
    return this.publishEvent('catalogue:goToPage', 1);
  };

  CataloguePageView.prototype.goToEnd = function() {
    return this.publishEvent('catalogue:goToPage', this.model.get('pages').length);
  };

  CataloguePageView.prototype.zoomIn = function() {
    var _ref1;
    this.flipZoom.toggleClass('animated');
    if ((_ref1 = this.flipZoom) != null ? _ref1.length : void 0) {
      return this.flipZoom.zoom('zoomIn');
    }
  };

  CataloguePageView.prototype.zoomOut = function() {
    var _ref1;
    if ((_ref1 = this.flipZoom) != null ? _ref1.length : void 0) {
      return this.flipZoom.zoom('zoomOut');
    }
  };

  CataloguePageView.prototype.print = function() {
    return window.print();
  };

  CataloguePageView.prototype.getActivePage = function(callback) {
    return callback(this.activePages);
  };

  CataloguePageView.prototype.preloadCurrentImages = function(activePages) {
    var endPage, i, _results;
    i = activePages[0] - config.preloadPageNum;
    endPage = activePages[0] + config.preloadPageNum;
    _results = [];
    while (i < endPage) {
      this.loadImageOnPage(this.flipbook.find("div.page[data-page-num='" + i + "']").get(0));
      _results.push(i++);
    }
    return _results;
  };

  CataloguePageView.prototype.loadImageOnPage = function(page) {
    var img;
    img = $(page).find('img');
    if (img.attr('src')) {
      return;
    }
    img.attr('src', img.attr('data-src'));
    return img.on('load', this.showImageOnLoad);
  };

  CataloguePageView.prototype.showImageOnLoad = function(e) {
    return $(e.currentTarget).fadeIn(300);
  };

  return CataloguePageView;

})(View);
